import { PageBody } from "ui";
import { PageWithHeaderAndFooter } from "@web/components/containers/PageWithHeaderAndFooter";
import { CameraData } from "@web/types/CameraData";
import { CameraTable } from "@web/components/tables/CameraTable";

type Props = {
  cameraDataArray: Array<CameraData>;
};

export function ComparePage({ cameraDataArray }: Props): JSX.Element {
  return (
    <PageWithHeaderAndFooter>
      <div>
        <PageBody hasHorizontalPadding>
          <CameraTable cameraDataArray={cameraDataArray} />
        </PageBody>
      </div>
    </PageWithHeaderAndFooter>
  );
}
